import { ChannelList, ChannelListProps } from 'stream-chat-react';
import { MessagingChannelPreview } from './MessagingChannelPreview/MessagingChannelPreview';

type MessagingSidebarProps = {
  channelListOptions: Pick<ChannelListProps, 'filters' | 'sort' | 'options'>;
};

export const MessagingSidebar = ({
  channelListOptions,
}: MessagingSidebarProps) => (
  <div className="str-chat messaging__sidebar str-chat__theme-light">
    <ChannelList {...channelListOptions} Preview={MessagingChannelPreview} />
  </div>
);
